import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePresentationPromoStore = defineStore('PresentationPromoStore', () => {
  const onStopCallback = ref(() => {
    // do nothing
  });

  return {
    onStopCallback, // run function at stop presentation promo
  };
});
